/**
 * vuex组装模块并导出 store 的地方
 *
 * @Author: weihaitao
 * @Date:   2018-1-31 10:45:26
 * @Last Modified by:   weihaitao
 * @Last Modified time: 2018-1-31 10:45:26
 */

import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import mutations from './mutations.js';
import * as actions from './actions.js';
import * as getters from './getters.js';
import createLogger from 'vuex/dist/logger'; // Vuex 自带一个日志插件用于一般的调试

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
/* eslint-disable object-shorthand */
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: debug,
  plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js